import React from 'react';

// Only the Totem and its portaled Ionic overlays receive these tokens.
export const getTotemThemeCss = (companyColor?: string): string => {
    const value = typeof companyColor === 'string' ? companyColor.trim() : '';
    const hex = /^#[\da-f]{6}$/i.test(value) ? value
        : /^#[\da-f]{3}$/i.test(value) ? '#' + value.slice(1).split('').map(c => c + c).join('')
        : '#d4251c';
    const rgb = [1, 3, 5].map(offset => parseInt(hex.slice(offset, offset + 2), 16));
    const luminance = rgb.map(channel => {
        const s = channel / 255;
        return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    }).reduce((total, channel, index) => total + channel * [0.2126, 0.7152, 0.0722][index], 0);
    const darkText = luminance > 0.179;
    const shade = rgb.map(channel => Math.round(channel * 0.88)).join(',');
    const tint = rgb.map(channel => Math.round(channel + (255 - channel) * 0.1)).join(',');

    return `.totem-page, .totem-themed-modal, .totem-selection-options {
        --ion-color-totem: ${hex};
        --ion-color-totem-rgb: ${rgb.join(',')};
        --ion-color-totem-contrast: ${darkText ? '#000000' : '#ffffff'};
        --ion-color-totem-contrast-rgb: ${darkText ? '0,0,0' : '255,255,255'};
        --ion-color-totem-shade: rgb(${shade});
        --ion-color-totem-tint: rgb(${tint});
        --ion-color-primary: var(--ion-color-totem);
        --ion-color-primary-rgb: var(--ion-color-totem-rgb);
        --ion-color-primary-contrast: var(--ion-color-totem-contrast);
        --ion-color-primary-contrast-rgb: var(--ion-color-totem-contrast-rgb);
        --ion-color-primary-shade: var(--ion-color-totem-shade);
        --ion-color-primary-tint: var(--ion-color-totem-tint);
    }`;
};

const TotemTheme: React.FC<{ color?: string }> = ({ color }) => (
    <style>{getTotemThemeCss(color)}</style>
);

export default TotemTheme;
